<template>
  <div v-if="messages.length > 0">
    <div v-for="message in messages" :key="message._id">
      <div class="messages">
        <div class="box message">
          <div class="message-header">
            <p class="is-size-6">
              <span>
                <span v-if="message.level === 'livegame'"><i class="fas fa-bullseye"></i></span>
                <span v-if="message.level === 'warning'"><i class="fas fa-skull-crossbones"></i></span>
                <span v-if="message.level === 'feature'"><i class="fas fa-crow"></i></span>
                <span v-if="message.level === 'information'"><i class="fas fa-info"></i></span>
                <span v-if="message.level === 'reminder'"><i class="fas fa-bell"></i></span>
                <span v-if="message.level === 'bug'"><i class="fas fa-bug"></i></span>
              </span>
              <span>{{ message.title }}</span>
            </p>
          </div>
          <div>
            <p class="is-size-6">{{ message.description }}</p>  
            <p class="is-size-6" v-if="message.level === 'livegame'"><a href="https://axes2.ca/display" target="new">View</a></p>
            <p style="font-size: 0.6em;">{{ message.start_date }}</p>  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';

export default {
  name: 'Messages',
  data() {
    return {
      debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
      messages: []
    }
  },
  methods: {
    getMessages() {
      const today = new moment().utc();
      const end = today;
      const start = end.clone().subtract(7, "days");
      
      // Build API URL directly (same logic as App.vue's getApiUrl)
      const baseUrl = this.debugMode 
        ? "http://localhost:8080" 
        : "https://axes2api.azurewebsites.net";
      const url = `${baseUrl}/current_messages/${start.format('YYYY-MM-DDTHH:mm:ss')}/${end.format('YYYY-MM-DDTHH:mm:ss')}`;
      
      this.messages = [];

      axios.get(url)
        .then((response) => {
          // Sort messages by start_date, most recent first
          this.messages = response.data.sort((a, b) => {
            return new Date(b.start_date) - new Date(a.start_date);
          }); 
        }, (error) => {
          if (this.debugMode) {
            console.log("Error getting broadcast messages:", error);
          }
        });
    }
  },
  mounted() {
    this.getMessages();
  }
}
</script>

<style lang="scss" scoped>
  .messages {
    max-width: 400px; 
    margin: auto;
  }
  .message {
    border-radius: 12px;
    background-color: white; 
    margin-bottom: 16px;
    padding: 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    transition: transform 0.2s, box-shadow 0.2s;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }
  }
  .message-header {
    background: linear-gradient(135deg, #2d5016 0%, #4a7c2f 100%);
    color: black;
    padding: 12px 16px;
    font-weight: 600;
    
    i {
      margin-right: 8px;
      font-size: 1.4em;
      color: #f4a300;
    }
    
    p, span {
      color: #f4a300;
    }
  }
  .message {
    div:not(.message-header) {
      padding: 16px;
      color: #333;
    }
    
    p {
      margin-bottom: 8px;
      color: #333;
      
      &:last-child {
        margin-bottom: 0;
        color: #666;
        font-style: italic;
      }
    }
    
    a {
      color: #4a7c2f;
      font-weight: 600;
      text-decoration: none;
      
      &:hover {
        text-decoration: underline;
        color: #2d5016;
      }
    }
  }
</style>
